// extracted by mini-css-extract-plugin
export var active = "_fi-7";
export var container = "_fi-0";
export var evenWidth = "_fi-4";
export var large = "_fi-5";
export var outlet = "_fi-8";
export var slide = "_fi-2";
export var small = "_fi-6";
export var tab = "_fi-3";
export var tabs = "_fi-1";